(function () {
  'use strict';

  document.documentElement.setAttribute('data-cc-growth-ready', 'true');

  var ATTRIBUTION_KEY = 'cc_attribution_v1';
  var SUCCESS_KEY = 'cc_lead_success_v1';
  var VIEW_KEY = 'cc_offer_views_v1';
  var ATTRIBUTION_TTL = 30 * 24 * 60 * 60 * 1000;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  // Custom campaign measurement needs analytics, marketing and sharing permission.
  function trackingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && privacy.analyticsProcessingAllowed() &&
      privacy.marketingAllowed() && privacy.saleOfDataAllowed());
  }

  function readStored(key, persistent) {
    if (!trackingAllowed()) return {};
    try {
      var storage = persistent ? window.localStorage : window.sessionStorage;
      return JSON.parse(storage.getItem(key) || '{}');
    } catch (error) {
      return {};
    }
  }

  function writeStored(key, value, persistent) {
    if (!trackingAllowed()) return;
    try {
      var storage = persistent ? window.localStorage : window.sessionStorage;
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function cleanLabel(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80);
  }

  function publish(eventName, details) {
    if (!trackingAllowed()) return;
    var payload = details || {};
    payload.event = eventName;
    payload.page_path = window.location.pathname;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, details || {});
    }

    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', eventName, details || {});
    }
  }

  function captureAttribution() {
    if (!trackingAllowed()) return {};
    var params = new URLSearchParams(window.location.search);
    var stored = readStored(ATTRIBUTION_KEY, true);
    var now = Date.now();
    var hasNewAttribution = false;

    if (stored.updated_at && now - stored.updated_at > ATTRIBUTION_TTL) stored = {};
    if (!stored.first_landing_path) {
      stored.first_landing_path = window.location.pathname;
      stored.first_referrer = document.referrer.slice(0, 300);
    }

    UTM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        stored[key] = value.slice(0, 160);
        hasNewAttribution = true;
      }
    });

    if (hasNewAttribution) {
      stored.campaign_landing_path = window.location.pathname;
    }

    stored.last_landing_path = window.location.pathname;
    stored.updated_at = now;
    writeStored(ATTRIBUTION_KEY, stored, true);

    return stored;
  }

  function offerFromUrl(url) {
    var value = (url.hostname + url.pathname).toLowerCase();
    if (value.indexOf('theobjective') !== -1 || value.indexOf('/the-objective') !== -1) return 'the-objective';
    if (value.indexOf('eliteroyalmarinescommando') !== -1 || value.indexOf('royal-marines-prep') !== -1) return 'royal-marines-prep';
    if (value.indexOf('wetheelite') !== -1) return 'we-the-elite';
    if (value.indexOf('militarypreparation') !== -1 || value.indexOf('military-prep-weekends') !== -1) return 'prep-weekend';
    if (value.indexOf('operational-fitness-events') !== -1) return 'fitness-wellness-events';
    if (value.indexOf('complete-commando-fitness-retreat') !== -1) return 'fitness-retreat';
    if (value.indexOf('wirral-ultra-cohort') !== -1) return 'ultra-cohort';
    if (value.indexOf('1-2-1-coaching') !== -1 || value.indexOf('whole-life-coaching') !== -1) return '1-2-1-coaching';
    if (value.indexOf('corporate-leadership-development') !== -1) return 'corporate-mentorship';
    if (value.indexOf('uk-military-preparation-handbook') !== -1) return 'military-handbook';
    if (value.indexOf('/collections/apparel') !== -1 || value.indexOf('/products/') !== -1 && value.indexOf('militarypreparation') === -1) return 'apparel';
    return '';
  }

  function appendHiddenField(form, name, value) {
    if (!trackingAllowed()) return;
    if (!value || form.querySelector('[name="' + name + '"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.setAttribute('data-cc-attribution-field', 'true');
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function attributionSummary(attribution) {
    return UTM_KEYS.map(function (key) {
      return attribution[key] ? key + '=' + attribution[key] : '';
    }).filter(Boolean).join(' | ') || 'Direct or untagged';
  }

  function decorateFitrLink(anchor, attribution) {
    var url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (error) {
      return null;
    }

    if (!trackingAllowed() || !/\.fitr\.training$/i.test(url.hostname)) return url;
    if (!anchor.hasAttribute('data-cc-original-href')) anchor.setAttribute('data-cc-original-href', anchor.getAttribute('href'));

    var offer = offerFromUrl(url) || 'programme';
    var content = cleanLabel(anchor.getAttribute('data-cc-cta') || anchor.textContent) || 'website-cta';
    url.searchParams.set('utm_source', attribution.utm_source || 'completecommando.com');
    url.searchParams.set('utm_medium', attribution.utm_medium || 'website');
    url.searchParams.set('utm_campaign', attribution.utm_campaign || offer);
    url.searchParams.set('utm_content', attribution.utm_content || content);
    anchor.href = url.toString();
    return url;
  }

  function initialiseLeadForms(attribution) {
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      var started = false;
      var leadType = form.id || 'contact-form';

      form.setAttribute('data-cc-lead-ready', 'true');
      appendHiddenField(form, 'contact[Campaign attribution]', attributionSummary(attribution));
      appendHiddenField(form, 'contact[First landing page]', attribution.first_landing_path || window.location.pathname);
      appendHiddenField(form, 'contact[Campaign landing page]', attribution.campaign_landing_path || 'Not recorded');
      appendHiddenField(form, 'contact[Last page before enquiry]', window.location.pathname);

      form.addEventListener('input', function () {
        if (started || !trackingAllowed()) return;
        started = true;
        form.setAttribute('data-cc-lead-started', 'true');
        publish('cc_lead_start', { lead_type: cleanLabel(leadType) });
      });

      form.addEventListener('submit', function () {
        form.setAttribute('data-cc-lead-submitted', 'true');
        publish('cc_lead_submit', { lead_type: cleanLabel(leadType) });
      });
    });

    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') !== 'true') return;

    var successId = window.location.pathname + window.location.hash;
    var successes = readStored(SUCCESS_KEY);
    if (successes[successId]) return;
    successes[successId] = Date.now();
    writeStored(SUCCESS_KEY, successes);
    publish('cc_lead_success', { lead_type: cleanLabel(window.location.pathname) });
  }

  function initialiseCommerceTracking() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        publish('cc_add_to_cart', { offer: offerFromUrl(new URL(window.location.href)) || 'shopify-product' });
      });
    });
  }

  function initialiseOfferView() {
    var offer = offerFromUrl(new URL(window.location.href));
    if (!offer) return;
    var views = readStored(VIEW_KEY);
    var key = window.location.pathname + ':' + offer;
    if (views[key]) return;
    views[key] = Date.now();
    writeStored(VIEW_KEY, views);
    publish('cc_offer_view', { offer: offer });
  }

  var attribution = {};
  var trackingStarted = false;

  document.addEventListener('pointerdown', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor) decorateFitrLink(anchor, attribution);
  });

  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;

    var url = decorateFitrLink(anchor, attribution);
    if (!url) return;

    var label = cleanLabel(anchor.getAttribute('data-cc-cta') || anchor.textContent);
    var offer = offerFromUrl(url);
    if (url.protocol === 'mailto:' || url.protocol === 'tel:') {
      publish('cc_contact_click', { method: url.protocol.replace(':', ''), cta: label || 'contact-link' });
      return;
    }
    var actionCopy = /join|start|book|apply|request|buy|enrol/.test(label);
    if (!offer || (!actionCopy && !/\.fitr\.training$/i.test(url.hostname))) return;

    publish('cc_offer_click', {
      offer: offer,
      cta: label || 'link',
      destination_host: url.hostname
    });
  });

  function syncTrackingConsent() {
    if (!trackingAllowed()) {
      attribution = {};
      try {
        window.localStorage.removeItem(ATTRIBUTION_KEY);
        window.sessionStorage.removeItem(SUCCESS_KEY);
        window.sessionStorage.removeItem(VIEW_KEY);
      } catch (error) { /* Storage can be disabled by the browser. */ }
      document.querySelectorAll('[data-cc-attribution-field]').forEach(function (field) { field.remove(); });
      document.querySelectorAll('a[data-cc-original-href]').forEach(function (anchor) {
        anchor.setAttribute('href', anchor.getAttribute('data-cc-original-href'));
        anchor.removeAttribute('data-cc-original-href');
      });
      return;
    }
    attribution = captureAttribution();
    if (!trackingStarted) {
      initialiseLeadForms(attribution);
      initialiseCommerceTracking();
      trackingStarted = true;
    } else {
      document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
        appendHiddenField(form, 'contact[Campaign attribution]', attributionSummary(attribution));
        appendHiddenField(form, 'contact[First landing page]', attribution.first_landing_path);
        appendHiddenField(form, 'contact[Campaign landing page]', attribution.campaign_landing_path || 'Not recorded');
        appendHiddenField(form, 'contact[Last page before enquiry]', window.location.pathname);
      });
    }
    initialiseOfferView();
  }

  document.addEventListener('visitorConsentCollected', syncTrackingConsent);
  syncTrackingConsent();
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) syncTrackingConsent();
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-cc-cookie-preferences]');
    if (!link || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    event.preventDefault();
    var popover = link.closest('[popover]');
    if (popover && typeof popover.hidePopover === 'function') popover.hidePopover();
    window.privacyBanner.showPreferences().catch(function () { window.location.href = link.href; });
  });
})();
